import React from "react";
//import { NavLink } from "react-router-dom";
import { Breadcrumbs } from "react-breadcrumbs-dynamic";
//import { BreadcrumbItem } from "react-bootstrap";

const Breadcrumb = () => {
  return (
    <div className="breadcrumb-area pt-2 pb-2 bg-gray-3">
      <div className="container">
        <div className="breadcrumb-content text-center ">
          <Breadcrumbs
            separator={<span>/</span>}
          
            finalItem={"span"}
            finalProps={{
              style: {color: "#ac846b"}
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
